export const CUSTOM_RECTANGLE =
    "w-[100%] lg:w-[4px] h-[4px] lg:h-[90%] rounded-lg mb-[23px] lg:mb-[0px]  bg-";
